import { render } from "./CriteriaCardB.vue?vue&type=template&id=6ba2f3e6&scoped=true"
import script from "./CriteriaCardB.vue?vue&type=script&lang=js"
export * from "./CriteriaCardB.vue?vue&type=script&lang=js"

import "./CriteriaCardB.vue?vue&type=style&index=0&id=6ba2f3e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba2f3e6"]])

export default __exports__